import axios from "axios";
import { base_url } from "../../../utils/baseUrl";



const getChapters = async (token) => {
  
  const response = await axios.get(`${base_url}chapters/getAllChapters`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    }
  });
 
  return response.data;
  
};
const createChapter = async (values) => {
  const token = values.get("token")  
  const response = await axios.post(
    `${base_url}chapters/addChapters`,
    values, // Pass form data directly
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    }
  );

  return response.data;
};

const updateChapter = async (values) => {
  const id = values.get("id") 
  const response = await axios.put(
    `${base_url}chapters/editChapters/${id}`,
    values,

  );

  return response.data;
};

const getChapter = async (id) => {
  const response = await axios.get(`${base_url}chapters/getById/${id}`);

  return response.data;
};

const deleteChapter = async (id) => {
  const response = await axios.delete(`${base_url}chapters/deleteChapters/${id}`);

  return response.data;
};
const ChapterService = {
  getChapters,
  createChapter,
  getChapter,
  updateChapter,
  deleteChapter,
};

export default ChapterService;
